/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CardAccountTransactionAuthorizationType = typeof CardAccountTransactionAuthorizationType[keyof typeof CardAccountTransactionAuthorizationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountTransactionAuthorizationType = {
  PURCHASE: 'PURCHASE',
  ATM: 'ATM',
} as const;
